/**
 * The list of an organization's agent runs (spec 2026-10-26-03). Same access
 * as the run page: data.write, or a platform admin (lib/route-permissions.ts).
 */
import { createFileRoute } from '@tanstack/react-router'
import {
    AgentRunsListPage,
    RUN_STATUS_FILTERS,
    RUN_TYPE_FILTERS,
    type AgentRunsListSearch,
} from '../../../components/agent-runs/AgentRunsListPage'

export const Route = createFileRoute('/$org/agent-runs/')({
    validateSearch: (search: Record<string, unknown>): AgentRunsListSearch => {
        const status = (RUN_STATUS_FILTERS as readonly unknown[]).includes(search.status)
            ? (search.status as AgentRunsListSearch['status'])
            : undefined
        const type = (RUN_TYPE_FILTERS as readonly unknown[]).includes(search.type)
            ? (search.type as AgentRunsListSearch['type'])
            : undefined
        const page = Number(search.page)
        return {
            ...(status ? { status } : {}),
            ...(type ? { type } : {}),
            ...(Number.isInteger(page) && page > 1 ? { page } : {}),
        }
    },
    component: RouteComponent,
})

function RouteComponent() {
    const { org } = Route.useParams()
    const search = Route.useSearch()
    return <AgentRunsListPage org={org} search={search} />
}
